import React from 'react'
import { ErrorBoundary as ErrorBoundaryComponent } from 'react-error-boundary'
import { ServerError } from '~components/pages/error/ServerError'
import { datadogRum } from '@datadog/browser-rum'

export const ErrorBoundary = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <ErrorBoundaryComponent onError={(err, info) => datadogRum.addError(err, info)} FallbackComponent={ServerError}>
    {children}
  </ErrorBoundaryComponent>
)

export const HidingErrorBoundary = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <ErrorBoundaryComponent onError={(err, info) => datadogRum.addError(err, info)} FallbackComponent={() => <></>}>
    {children}
  </ErrorBoundaryComponent>
)
